<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row mt-2">

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-3">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(InternalTransferRequestStatus).filter(item => item === parseInt(item))"
                                   :custom-label="(opt) => helper.trans(`internal_transfer_request_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-3">
                  <div class="col p-0">
                    <div class="">
                      <MerchantMultiselect :multiple="true" v-model="merchantsFilter">
                      </MerchantMultiselect>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group mb-2 me-2 col-md-5 col-lg-5 col-xl-5">
                  <div class="d-flex align-items-center gap-1">
                    <label class="col-sm-3 col-form-label text-capitalize-first p-0 me-1">{{ helper.trans("labels.from_account") }}:</label>
                    <button type="button" class="btn btn-sm btn-outline-dark text-capitalize-first"  @click.prevent="toggleFromType()">{{ fromAccountType ? helper.trans(`labels.${fromAccountType}`) : helper.trans(`labels.select`)  }}</button>
                    <div class="w-100" v-if="fromAccountType && fromAccountType !== 'system'">
                      <Multiselect
                        class="multiselect-sm"
                        v-model="requestDTO.fromAccount"
                        :options="fromAccounts"
                        :custom-label="(opt) => labelFor(fromAccountType!, opt)"
                        track-by="id"
                        select-label="Select"
                        open-direction="bottom"
                        :multiple="false"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="1000"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindFromAccounts"
                      >
                      </Multiselect>
                    </div>
                    <button v-if="fromAccountType" type="button" class="btn btn-sm btn-link" @click.prevent="clearFromType()"><i class="fa fa-times"></i></button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group mb-2 me-2 col-md-5 col-lg-5 col-xl-5">
                  <div class="d-flex align-items-center gap-1">
                    <label class="col-sm-3 col-form-label text-capitalize-first p-0 me-1">{{ helper.trans("labels.to_account") }}:</label>
                    <button type="button" class="btn btn-sm btn-outline-dark text-capitalize-first"  @click.prevent="toggleToType()">{{ toAccountType ? helper.trans(`labels.${toAccountType}`) : helper.trans(`labels.select`)  }}</button>
                    <div class="w-100" v-if="toAccountType && toAccountType !== 'system'">
                      <Multiselect
                        class="multiselect-sm"
                        v-model="requestDTO.toAccount"
                        :options="toAccounts"
                        :custom-label="(opt) => labelFor(toAccountType!, opt)"
                        track-by="id"
                        select-label="Select"
                        open-direction="bottom"
                        :multiple="false"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="1000"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindToAccounts"
                      >
                      </Multiselect>
                    </div>
                    <button v-if="toAccountType" type="button" class="btn btn-sm btn-link" @click.prevent="clearToType()"><i class="fa fa-times"></i></button>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => exportData()" class="btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first">
                      <i class="fa fa-download me-1"></i>{{ helper.trans('button.export') }}
                    </button>
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button v-if="isAdmin && store.getters.hasPermission(UserPermission.BALANCE_CORRECTION)" type="button" @click.prevent="openBalanceCorrection()" class="btn btn-outline-dark btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.balance_correction') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.created') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans("labels.from_account") }}</th>
                    <th class="text-capitalize-first"></th>
                    <th class="text-capitalize-first">{{ helper.trans("labels.to_account") }}</th>
                    <th class="text-capitalize-first"></th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans("labels.status") }}</th>
                    <th class="text-end">
                      <button v-if="!isOperatorRestricted" type="button" v-on:click="showEditModal()" class="btn btn-outline-primary btn-sm text-capitalize">{{ helper.trans('button.create') }}</button>
                      <b-modal
                        dialog-class="modal-lg"
                        :title="helper.trans('labels.create_internal_transfer_request')"
                        :modelValue="createModal"
                        body-class="pt-0"
                        @update:modelValue="createModal = $event"
                      >
                        <template #default>
                          <InternalTransferForm ref="createForm"></InternalTransferForm>
                        </template>
                        <template #footer>
                          <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                          <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                            <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                          </LoaderWrapper>
                        </template>
                      </b-modal>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in response.items" :key="item.id" class="">
                    <td>
                      <span>{{ item.id }}</span>
                    </td>
                    <td>
                      <div class="d-flex flex-column">
                        <UserNameLabel v-if="item._createdBy" show-badge :user="item._createdBy"></UserNameLabel>
                        <small class="text-secondary">{{ dateHelper.format(item.createdAt) }}</small>
                      </div>
                    </td>
                    <td>
                      <UserNameLabel v-if="item._fromSystemAccount" show-badge :user="systemUser"></UserNameLabel>
                      <UserNameLabel v-if="item._fromTraderAccount" show-badge :user="item._fromTraderAccount.user"></UserNameLabel>
                      <UserNameLabel v-if="item._fromUserAccount" show-badge :user="item._fromUserAccount.user"></UserNameLabel>
                      <div v-if="item._fromMerchantStoreAccount" class="d-flex flex-row align-items-center">
                        <div>
                          <UserNameLabel show-badge :user="item._fromMerchantStoreAccount.user"></UserNameLabel>
                          <div class="d-flex" style="clear: both">{{item._fromMerchantStoreAccount?.storeName }}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div v-if="item.status === InternalTransferRequestStatus.STATUS_NEW">
                        <AccountWidget v-if="item._fromTraderAccount" :account="item._fromTraderAccount.account"></AccountWidget>
                        <AccountWidget v-if="item._fromMerchantStoreAccount" :account="item._fromMerchantStoreAccount.account"></AccountWidget>
                        <AccountWidget v-if="item._fromUserAccount" :account="item._fromUserAccount.account"></AccountWidget>
                        <AccountWidget v-if="item._fromSystemAccount" :account="item._fromSystemAccount"></AccountWidget>
                      </div>
                    </td>

                    <td>
                      <UserNameLabel v-if="item._toSystemAccount" show-badge :user="systemUser"></UserNameLabel>
                      <UserNameLabel v-if="item._toTraderAccount" show-badge :user="item._toTraderAccount.user"></UserNameLabel>
                      <UserNameLabel v-if="item._toUserAccount" show-badge :user="item._toUserAccount.user"></UserNameLabel>
                      <div v-if="item._toMerchantStoreAccount" class="d-flex flex-row align-items-center">
                        <div>
                          <UserNameLabel show-badge :user="item._toMerchantStoreAccount.user"></UserNameLabel>
                          <div class="d-flex" style="clear: both">{{item._toMerchantStoreAccount?.storeName }}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div v-if="item.status === InternalTransferRequestStatus.STATUS_NEW">
                        <AccountWidget v-if="item._toTraderAccount" :account="item._toTraderAccount.account"></AccountWidget>
                        <AccountWidget v-if="item._toMerchantStoreAccount" :account="item._toMerchantStoreAccount.account"></AccountWidget>
                        <AccountWidget v-if="item._toUserAccount" :account="item._toUserAccount.account"></AccountWidget>
                        <AccountWidget v-if="item._toSystemAccount" :account="item._toSystemAccount"></AccountWidget>
                      </div>
                    </td>


                    <td>{{ numberFormatter.formatMoney(item.sum, 2) }}</td>
                    <td>{{ helper.trans(`internal_transfer_request_status.${item.status}`) }}</td>
                    <td>
                      <div v-if="item.status === InternalTransferRequestStatus.STATUS_NEW" class="text-end">
                        <button v-if="!isOperatorRestricted || store.getters.hasPermission(UserPermission.INTERNAL_TRANSFER)" type="button" @click="cancel(item.id)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2">{{helper.trans('button.cancel')}}</button>
                        <button v-if="isAdmin || isOperator && store.getters.hasPermission(UserPermission.INTERNAL_TRANSFER)" :disabled="item.createdById === user.id" type="button" @click="process(item.id)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize">{{helper.trans('button.transfer')}}</button>
                      </div>
                      <div v-else-if="item.updatedAt" class="d-flex flex-column">
                        <UserNameLabel v-if="item._updatedBy" show-badge :user="item._updatedBy"></UserNameLabel>
                        <small class="text-secondary">{{ dateHelper.format(item.updatedAt) }}</small>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <ConfirmModal ref="confirmModal"></ConfirmModal>
    <BalanceCorrectionModal 
      :showModal="balanceCorrectionModal" 
      @update:showModal="balanceCorrectionModal = $event"
      @success="load"
    />
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {internalTransferRequests} from "@/service/api/internalTransferRequests";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TraderAccountDTO from "@/models/TraderAccountDTO";
import PaginationDTO from "@/models/PaginationDTO";
import MerchantStoreAccountDTO from "@/models/MerchantStoreAccountDTO";
import UserAccountDTO from "@/models/UserAccountDTO";
import {UserRole} from "@/models/enum/UserRole";
import Multiselect from "vue-multiselect";
import {InternalTransferRequestStatus} from "@/models/enum/InternalTransferRequestStatus";
import InternalTransferRequestDTO from "@/models/InternalTransferRequestDTO";
import InternalTransferRequestFormDTO from "@/models/form/InternalTransferRequestFormDTO";
import InternalTransferForm from "@/components/Form/InternalTransferForm.vue";
import AccountWidget from "@/components/AccountWidget.vue";
import UserNameLabel from "@/components/UserNameLabel.vue";
import AccountDTO from "@/models/AccountDTO";
import UserDTO, {SystemUser} from "@/models/UserDTO";
import {UserPermission} from "@/models/enum/UserPermission";
import BalanceCorrectionModal from "@/components/BalanceCorrectionModal.vue";
import MerchantMultiselect from "@/components/MerchantMultiselect.vue";
import MerchantDTO from "@/models/MerchantDTO";

const api = new APIClient();
const notification = useNotification()
const systemUser = SystemUser;
const defaultRequestDTO = {
  statuses: [InternalTransferRequestStatus.STATUS_NEW],
  fromAccountId: null,
  toAccountId: null,
  fromAccount: null,
  toAccount: null,
}
const defaultForm = {
  amount: null,
  fromAccountType: "system",
  fromAccount: null,
  toAccountType: 'trader',
  toAccount: null
} as InternalTransferRequestFormDTO

const types = [null, 'system', 'trader', 'teamlead', 'store'];

export default defineComponent({
  components: {
    UserNameLabel,
    AccountWidget,
    InternalTransferForm,
    Multiselect,
    MerchantMultiselect,
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
    BalanceCorrectionModal
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)
    const createForm = ref<InstanceType<typeof InternalTransferForm> | null>(null)

    const state = reactive({
      isLoading: false as boolean,
      fromAccountType: null as string|null,
      toAccountType: null as string|null,
      fromAccounts: [] as TraderAccountDTO[]|MerchantStoreAccountDTO[]|UserAccountDTO[],
      toAccounts: [] as TraderAccountDTO[]|MerchantStoreAccountDTO[]|UserAccountDTO[],
      createModal: false as boolean,
      balanceCorrectionModal: false as boolean,
      isSubmitting: false as boolean,
      page: 1,
      merchantsFilter: [] as MerchantDTO[],
      requestDTO: {...defaultRequestDTO} as any,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<InternalTransferRequestDTO>
    });

    const load = async () => {
      state.response.offset = state.response.limit * (state.page - 1)
      loader.value?.show()
      const filters: any = {
        statuses: state.requestDTO.statuses,
        fromAccountId: state.requestDTO.fromAccount ? state.requestDTO.fromAccount.id : state.requestDTO.fromAccountId,
        toAccountId: state.requestDTO.toAccount ? state.requestDTO.toAccount.id : state.requestDTO.toAccountId,
      }

      if (state.merchantsFilter.length > 0) {
        filters.merchantIds = state.merchantsFilter.map(m => m.id)
      }

      state.response = await api.call.internalTransferRequests.list(state.response, filters)

      let accountIds = [];
      let userIds = [];
      for (const req of state.response.items) {
        accountIds.push(req.fromAccountId)
        accountIds.push(req.toAccountId)
        if (req.createdById) {
          userIds.push(req.createdById)
        }
        if (req.updatedById) {
          userIds.push(req.updatedById)
        }
      }


      let users = {} as UserDTO[]|any;
      if (userIds.length > 0) {
        for (const user of (await api.users({offset:0, limit: 1000} as PaginationDTO, {ids: userIds})).items) {
          users[user.id] = user
        }
      }

      let userAccounts = {} as UserAccountDTO[]|any;
      let storeAccounts = {} as MerchantStoreAccountDTO[]|any;
      let traderAccounts = {} as TraderAccountDTO[]|any;
      const systemAccounts = {
        '00000000-0000-0000-0000-000000000000': await api.accountsGet('00000000-0000-0000-0000-000000000000')
      } as AccountDTO[]|any

      if (accountIds.length > 0) {
        for (const account of (await api.traderAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
          traderAccounts[account.account.id] = account
        }
        for (const account of (await api.merchantStoreAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
          storeAccounts[account.account.id] = account
        }
        for (const account of (await api.userAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
          userAccounts[account.account.id] = account
        }
      }

      for (const item of state.response.items) {
        item._fromTraderAccount = traderAccounts[item.fromAccountId] ?? null;
        item._fromMerchantStoreAccount = storeAccounts[item.fromAccountId] ?? null;
        item._fromUserAccount = userAccounts[item.fromAccountId] ?? null;
        item._fromSystemAccount = systemAccounts[item.fromAccountId] ?? null;

        item._toTraderAccount = traderAccounts[item.toAccountId] ?? null;
        item._toMerchantStoreAccount = storeAccounts[item.toAccountId] ?? null;
        item._toUserAccount = userAccounts[item.toAccountId] ?? null;
        item._toSystemAccount = systemAccounts[item.toAccountId] ?? null;


        if (item.createdById) {
          item._createdBy = users[item.createdById] ?? null
        }
        if (item.updatedById) {
          item._updatedBy = users[item.updatedById] ?? null
        }
      }


      loader.value?.hide()
    }

    const process = async (id: number) => {
      loader.value?.show()
      await api.call.internalTransferRequests.complete(id)
      load()
    }

    const cancel = async (id: number) => {
      loader.value?.show()
      await api.call.internalTransferRequests.cancel(id)
      load()
    }

    const exportData = async () => {
      try {
        loader.value?.show()
        const params: any = {}
        
        if (state.requestDTO.statuses && state.requestDTO.statuses.length > 0) {
          params.statuses = state.requestDTO.statuses
        }
        
        if (state.requestDTO.fromAccount) {
          params.fromAccountId = state.requestDTO.fromAccount.id
        } else if (state.requestDTO.fromAccountId) {
          params.fromAccountId = state.requestDTO.fromAccountId
        }

        if (state.requestDTO.toAccount) {
          params.toAccountId = state.requestDTO.toAccount.id
        } else if (state.requestDTO.toAccountId) {
          params.toAccountId = state.requestDTO.toAccountId
        }

        if (state.merchantsFilter.length > 0) {
          params.merchantIds = state.merchantsFilter.map(m => m.id)
        }

        const blob = await internalTransferRequests.export(params)
        const filename = `internal_transfers_${new Date().toISOString().split('T')[0]}.xlsx`
        helper.downloadBlob(blob, filename)
      } catch (error) {
        notification.notify({
          title: 'Ошибка экспорта',
          text: 'Не удалось экспортировать данные',
          type: 'error'
        })
      } finally {
        loader.value?.hide()
      }
    }


    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {...defaultRequestDTO}
      state.merchantsFilter = []
      clearToType()
      clearFromType()
      load()
    }

    const showEditModal = async () => {
      createForm.value?.setForm({...defaultForm} as InternalTransferRequestFormDTO)

      state.createModal = true;
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      createForm.value!.save()
        .then(() => {
          state.createModal = false;
          load();
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })
    }

    const openBalanceCorrection = () => {
      state.balanceCorrectionModal = true
    }


    const labelFor = (type: string, opt: TraderAccountDTO|UserAccountDTO|MerchantStoreAccountDTO) => {
      if (type === 'store') {
        const storeAccount = opt as MerchantStoreAccountDTO
        return `${storeAccount.user.name} ${storeAccount.storeName} ${storeAccount.account.currency}`
      }

      return `${opt.user.name} (${opt.user.email})`
    }

    const asyncFindFromAccounts = debounce(async (query) => {
      state.isLoading = true
      switch (state.fromAccountType) {
        case 'trader':
          state.fromAccounts = (await api.traderAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
        case 'teamlead':
          state.fromAccounts = (await api.userAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query, userRole: UserRole.TRADER_TEAM_LEAD})).items;
          break;
        case 'store':
          state.fromAccounts = (await api.merchantStoreAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
      }

      state.isLoading = false
    }, 500);

    const asyncFindToAccounts = debounce(async (query) => {
      state.isLoading = true
      switch (state.toAccountType) {
        case 'trader':
          state.toAccounts = (await api.traderAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
        case 'teamlead':
          state.toAccounts = (await api.userAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query, userRole: UserRole.TRADER_TEAM_LEAD})).items;
          break;
        case 'store':
          state.toAccounts = (await api.merchantStoreAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
      }
      state.isLoading = false
    }, 500);

    const toggleFromType = () => {
      const index = state.fromAccountType ? types.indexOf(state.fromAccountType) : 0;
      let newValue = types[index + 1];
      state.fromAccountType = newValue ?? types[0]
      state.fromAccounts = []
      state.requestDTO.fromAccount = null;
      state.requestDTO.fromAccountId = null
      if (state.fromAccountType === 'system') {
        state.requestDTO.fromAccountId = '00000000-0000-0000-0000-000000000000';
      } else if (state.fromAccountType === null) {
        state.requestDTO.fromAccountId = null
      }
    }

    const toggleToType = () => {
      const index = state.toAccountType ? types.indexOf(state.toAccountType) : 0;
      let newValue = types[index + 1];
      state.toAccountType = newValue ?? types[0]
      state.toAccounts = []
      state.requestDTO.toAccount = null;
      state.requestDTO.toAccountId = null
      if (state.toAccountType === 'system') {
        state.requestDTO.toAccountId = '00000000-0000-0000-0000-000000000000';
      } else if (state.toAccountType === null) {
        state.requestDTO.toAccountId = null
      }
    }

    const clearToType = () => {
      state.toAccountType = null
      state.toAccounts = []
      state.requestDTO.toAccount = null;
      state.requestDTO.toAccountId = null
    }

    const clearFromType = () => {
      state.fromAccountType = null
      state.fromAccounts = []
      state.requestDTO.fromAccount = null;
      state.requestDTO.fromAccountId = null
    }

    onMounted(() => {
      load();
    });

    return {
      ...toRefs(state),
      store,
      systemUser,
      user: computed(() => store.getters.getUser),
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      isOperatorRestricted: computed(() => store.getters.isOperator && !!store.getters.getAppData?.OPERATOR_PAYMENT_DUTY_SEPARATION_ENABLED),
      applyFilters,
      clearFilters,
      save,
      showEditModal,
      loader,
      dateHelper,
      numberFormatter,
      confirmModal,
      loaderCreateFrom,
      createForm,
      helper,
      load,
      process,
      cancel,
      UserRole,
      InternalTransferRequestStatus,
      asyncFindFromAccounts,
      asyncFindToAccounts,
      toggleFromType,
      toggleToType,
      labelFor,
      clearFromType,
      clearToType,
      UserPermission,
      exportData,
      openBalanceCorrection,
    }
  }
})
</script>
